import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from './utils/ProjectedRoute';
import './App.css';
import './styles/fonts.css';

import HeaderNew from "./components/Playables/Header/Headernew";
import Footer from "./components/Playables/Footer/Footer";
import ScrollToTop from './components/utils/ScrollToTop';
import Home from './components/Home';
import IndustriesPage from './components/Industries/IndustriesPage';
import GamesPage from './components/Game Categories/GameCategoriesPage';
import CaseStudyPage from './components/CaseStudy/CaseStudyPage';
import IndustryBrandsPage from "./components/Brands/IndustryBrandsPage";
import BrandPlayablesPage from './components/Brands/BrandPlayablesPage';
import PlayableInstructionsPage from './components/Brands/PlayableInstructionsPage';
import CategoryPlayablesPage from './components/Brands/CategoryPlayablesPage';
import AnalyticsPage from './components/Analytics/AnalyticsPage';
import Login from './components/Login/Login';

function App() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  return (


    <div className=''>

      <ScrollToTop />
      {!isLoginPage && <HeaderNew />}

      <Routes>

        <Route path='/login' element={<Login />} />
        <Route path="*" element={<h1>404 Not Found</h1>} />

        <Route path="/" element={<ProtectedRoute><Home /> </ProtectedRoute>} />
        <Route path="/case-study" element={<ProtectedRoute><CaseStudyPage /></ProtectedRoute>} />
        <Route
          path="/playable/:playableId"
          element={<ProtectedRoute><PlayableInstructionsPage /></ProtectedRoute>}
        />
        <Route
          path="/industries/:industrySlug/:brandSlug"
          element={<ProtectedRoute><BrandPlayablesPage /></ProtectedRoute>}
        />
        <Route path="/categories/:categorySlug" element={<ProtectedRoute><CategoryPlayablesPage /></ProtectedRoute>} />
        <Route path="/games/:categorySlug" element={<ProtectedRoute><CategoryPlayablesPage /></ProtectedRoute>} />
        <Route
          path="/industries/:industrySlug"
          element={<ProtectedRoute><IndustryBrandsPage /></ProtectedRoute>}
        />
        <Route path="/industries" element={<ProtectedRoute><IndustriesPage /></ProtectedRoute>} />
        <Route path="/games" element={<ProtectedRoute><GamesPage /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
      </Routes>

      {!isLoginPage && <Footer />}
    </div>
  );
}

export default App;